//@flow
import { commitMutation, graphql } from 'react-relay';
import type { PayloadError } from 'react-relay';

const mutation = graphql`
    mutation profileAboutMutation($input: DesignProfileBasicMutationInput!) {
        designProfileBasicMutation(input: $input) {
            tradeFirm {
                publicProfile {
                    about
                }
            }
        }
    }
`;

type ProfileAboutMutationArgs = {
    firmId: string,
    about: string,
};

export const profileAboutMutation = (
    environment: Object,
    args: ProfileAboutMutationArgs
): Promise<void> => {
    const { firmId, about } = args;
    const input = {
        serviceId: firmId,
        about,
    };

    return new Promise((resolve, reject) => {
        const onCompleted = (response, errors: ?Array<PayloadError>) => {
            if (errors && errors.length) {
                reject(errors);
            }
            resolve(response);
        };

        const onError = (error: Error) => {
            reject([error]);
        };

        try {
            commitMutation(environment, {
                mutation,
                variables: { input },
                onCompleted,
                onError,
            });
        } catch (error) {
            reject([error]);
        }
    });
};
